import React from "react";
import { Button } from '../../ui/button';
import { REPORTS_CONSTANTS } from "../../sharedfiles/Constants";
import { DatePicker as Datepicker } from "../../ui/date-picker";
import Tooltips from "../Common/Tooltip";

function SearchReport(props) {
  const { reportTitle, dateFrom, dateTo, errors, setValue, submit } = props;
  return (
    <React.Fragment>
      <div className='rounded-lg border bg-card p-6'>
        <div className='border-b pb-4 mb-6'>
          <div className='text-lg font-semibold'>{reportTitle}</div>
        </div>
        <div className='flex flex-wrap justify-center'>
          <div className='w-full md:w-1/2 lg:w-1/3 xl:w-1/3 px-3'>
            <div className='flex items-start gap-4'>
              <div className='w-1/3'>
                <div className='text-sm font-medium text-muted-foreground'>
                  {REPORTS_CONSTANTS.report_dateFrom}
                  &nbsp;&nbsp;
                  <Tooltips info={REPORTS_CONSTANTS.report_dateFrom} />
                </div>
              </div>
              <div className='w-2/3'>
                <Datepicker
                  name={"dateFrom"}
                  value={dateFrom}
                  setValue={(date, name) => setValue(date, name)}
                  maxDate={dateTo || new Date()}
                  inline={true}
                  errorMsg={errors?.dateFrom}
                  ids={"datefrom"}
                // errorMsg={"please select Date From"}
                />
              </div>
            </div>
          </div>
          <div className='w-full md:w-1/2 lg:w-1/3 xl:w-1/3 px-3'>
            <div className='flex items-start gap-4'>
              <div className='w-1/3'>
                <div className='text-sm font-medium text-muted-foreground'>
                  {REPORTS_CONSTANTS.report_dateTo}
                  &nbsp;&nbsp;
                  <Tooltips info={REPORTS_CONSTANTS.report_dateTo} />
                </div>
              </div>
              <div className='w-2/3'>
                <Datepicker
                  name={"dateTo"}
                  value={dateTo}
                  setValue={(date, name) => setValue(date, name)}
                  maxDate={new Date()}
                  minDate={dateFrom}
                  inline={true}
                  errorMsg={errors?.dateTo}
                  ids={"dateTo"}
                // errorMsg={"please select Date To"}
                />
              </div>
            </div>
          </div>
        </div>

        <div className='mt-20'></div>

        <div className='flex flex-wrap -mx-3'>
          <div className='w-full px-3'>
            <div className='flex flex-wrap gap-3'>
              <Button
                onClick={(e) => submit(e)}
                type='button'
                id="submitbtn"
                variant="secondary"
              >
                {REPORTS_CONSTANTS.report_viewBtn}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default SearchReport;
